// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Caml_string from "../../../../../../../node_modules/rescript/lib/es6/caml_string.js";
import * as Router from "next/router";
import ReactAutocomplete from "react-autocomplete";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as CountryHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CountryHelpers.mjs";
import * as MapApiCustomHook$PorterinFeature from "../../../maps/MapApiCustomHook.mjs";
import UsePlacesAutocompleteServiceJs from "react-google-autocomplete/lib/usePlacesAutocompleteService.js";

function GoogleReactAutocompleteCmpMod(Props) {
  var id = Props.id;
  var value = Props.value;
  var api_key = Props.api_key;
  var form_on_change = Props.form_on_change;
  var placeholder = Props.placeholder;
  var response_typeOpt = Props.response_type;
  var wrapperStyle = Props.wrapperStyle;
  var menuStyle = Props.menuStyle;
  var inputClass = Props.inputClass;
  var itemClass = Props.itemClass;
  var response_type = response_typeOpt !== undefined ? response_typeOpt : /* Geocode */1;
  var match = Router.useRouter();
  var match$1 = React.useState(function () {
        return [];
      });
  var setPredictedArray = match$1[1];
  var predictedArray = match$1[0];
  var mapInst = document.getElementById("map");
  var match$2 = MapApiCustomHook$PorterinFeature.useGoogleAutoComplete(mapInst);
  var getAddressDetailsGeocode = match$2[1];
  var getAddressDetailsPlaceAutocomplete = match$2[0];
  var serviceResponse = UsePlacesAutocompleteServiceJs({
        apiKey: api_key,
        debounce: 500,
        options: {
          componentRestrictions: {
            country: CountryHelpers$PorterinUtils.countryCodeFromLocale(match.locale)
          }
        }
      });
  React.useEffect((function () {
          JsBindings$PorterinUtils.setAddressAutoFillOff("custom-autocomplete-" + id);
        }), [mapInst]);
  React.useEffect((function () {
          if (serviceResponse.placePredictions.length !== 0) {
            var predictedArray = serviceResponse.placePredictions;
            Curry._1(setPredictedArray, (function (param) {
                    return predictedArray;
                  }));
          }
          
        }), [serviceResponse.placePredictions]);
  var handleAddressSelect = function (place_id, address_response) {
    if (response_type === /* Geocode */1) {
      Curry._2(getAddressDetailsGeocode, place_id, form_on_change);
    } else {
      Curry._3(getAddressDetailsPlaceAutocomplete, place_id, form_on_change, address_response);
    }
    Curry._1(setPredictedArray, (function (param) {
            return [];
          }));
  };
  return React.createElement(ReactAutocomplete, {
              items: Belt_Array.mapWithIndex(predictedArray, (function (idx, ele) {
                      return {
                              place_id: ele.place_id,
                              description: String(idx) + ele.description
                            };
                    })),
              getItemValue: (function (a) {
                  return a.description;
                }),
              renderItem: (function (a) {
                  return React.createElement("div", {
                              key: a.place_id,
                              className: itemClass
                            }, $$String.sub(a.description, 1, a.description.length - 1 | 0));
                }),
              value: value,
              onSelect: (function (text) {
                  if (text.length !== 0) {
                    handleAddressSelect(Caml_array.get(predictedArray, Caml_string.get(text, 0) - 48 | 0).place_id, $$String.sub(text, 1, text.length - 1 | 0));
                  }
                  document.getElementById("custom-autocomplete-" + id).blur();
                }),
              onChange: (function ($$event) {
                  Curry._2(form_on_change, {
                        landmark: $$event.target.value,
                        location: {
                          lat: 0.0,
                          lng: 0.0
                        }
                      }, {
                        pincode: undefined,
                        state: undefined,
                        city: undefined,
                        locality: undefined,
                        sub_locality: undefined
                      });
                  Curry._1(serviceResponse.getPlacePredictions, {
                        input: $$event.target.value
                      });
                }),
              inputProps: {
                placeholder: placeholder,
                id: "custom-autocomplete-" + id,
                className: inputClass
              },
              menuStyle: menuStyle,
              wrapperStyle: wrapperStyle
            });
}

var make = GoogleReactAutocompleteCmpMod;

export {
  make ,
}
/* react Not a pure module */
